import React, {Component, Fragment} from 'react'
import {connect} from "react-redux";
import {asideRightOpen, asideCollapse} from "../../../../store/actions/GlobalActions";
import {Form, InputGroup, OverlayTrigger, Tooltip} from "react-bootstrap";
import {Query} from "react-apollo";

import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'
import Col from "react-bootstrap/Col";
import {ButtonWithBadge, ButtonWithIcon} from "../../../ui/forms/Buttons";
import SelectFilter from "../../../ui/select/SelectFilter";
import SelectSearch from "../../../ui/select/SelectSearch";

import icnCompare from '../../../../assets/svg/actions/icn-compare.svg';
import icnFilter from '../../../../assets/svg/actions/icn-filter.svg';
import {Link} from "react-router-dom";


import {talentSearchQueries} from "../../../../store/actions/Dashboard/TalentSearch/TalentSearchGraphQL";
import * as queryString from "query-string";
import {setCountriesFilter, setRegionsFilter, setSearchValue} from "../../../../store/actions/Dashboard/TalentSearch/TalentSearchActions";
import Tools from "../../../../Tools";
import {talentSearchTypes} from "../../../../store/actions/Dashboard/TalentSearch/actionsType";

library.add(fas, far);

class MainToolbar extends Component {

    state = {
        isBookMark: false
    };

    onBookmarkOn = () => {
        this.setState({
            isBookMark: !this.state.isBookMark
        })
    };

    clearMarkedList = (e) => {
        e.preventDefault();
        // add event this.props.clearMarkedList() to clear bookmark list on parent state and db
    };

    asideRightOpen = () => {
        this.props.asideRightOpen(true);
        this.props.asideCollapse(true);
    };

    render = () => {
        const {handleSearchChange} = this;
        const {tempSearch} = this.props;

        return (
            <Form onSubmit={this.handleSubmit} className="toolbar">
                <Form.Row className="row form">
                    <Col className="col-xl-3 col order-xl-0 order-1 pr-0 mr-3">
                        <InputGroup className="input-group-white-lg">
                            <Form.Control name="text" placeholder="Search Players, Sports clubs, teams...etc" className="input input-white input-lg" value={tempSearch} onChange={handleSearchChange}/>
                            <InputGroup.Append>
                                <InputGroup.Text>
                                    <i className="icon search-icon"/>
                                </InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                    </Col>

                    <Col className="col-xl-2 col order-xl-0 order-1 pr-0 mr-3">
                        {this.renderRegionsFilter()}
                    </Col>

                    <Col className="col-xl-2 col order-xl-0 order-1 pr-0 mr-3">
                        {this.renderCountriesFilter()}
                    </Col>

                    <Col className="col-xl col-12 mb-3">
                        <div className="h-100 w-100 d-flex align-items-center justify-content-end">
                            {this.renderBookmarkButton()}
                            {this.renderCompareButton()}

                            {
                                !this.props.aside_right_open ? (
                                    <ButtonWithIcon variant="primary" size={"lg"} text="Filters" svg={icnFilter} className="w-auto mr-0" onClick={this.asideRightOpen}/>
                                ) : null
                            }
                        </div>
                    </Col>
                </Form.Row>
            </Form>
        );
    };

    renderRegionsFilter = () => {
        const {handleRegionsChange} = this;
        const placeholder = "Players from all Regions";

        return (
            <Query query={talentSearchQueries.getRegions}>
                {({data, loading, error}) => {
                    let regionsOptions = [];

                    if (data?.regions) {
                        regionsOptions = data?.regions?.map(region => (
                            {
                                label: region.name,
                                value: region.id,
                                key: region.id,
                            }
                        ));
                    }

                    if (regionsOptions.length > 0)
                        regionsOptions = [{value: 'all', label: 'Select All', 'key': 'all'}, ...regionsOptions];

                    return (
                        <SelectFilter
                            type="lg"
                            color="white"
                            name="regions"
                            selected="true"
                            placeholder={placeholder}
                            options={regionsOptions}
                            // selectedValue={this.props.regions}
                            loading={loading}
                            error={error}
                            onDoneClick={handleRegionsChange}
                        />
                    );
                }}
            </Query>
        );
    };

    renderCountriesFilter = () => {
        const {handleCountriesChange} = this;
        const placeholder = "Players from all countries";
        const searchPlaceholder = "Search Country";

        const {regions: selectedRegions} = this.props;

        return (
            <Query query={talentSearchQueries.getCountriesByRegionsId} variables={{regionsIds: selectedRegions.map(item => item.value)}}>
                {({data, loading, error}) => {
                    let countriesOptions = [];
                    if (data?.countries) countriesOptions = data?.countries?.map(country => (
                        {
                            label: country.name,
                            value: country.id,
                            key: country.id,
                        }
                    ));

                    if (countriesOptions.length > 0)
                        countriesOptions = [{value: 'all', label: 'Select All', 'key': 'all'}, ...countriesOptions];

                    return (
                        <SelectSearch
                            type="lg"
                            color="white"
                            name="countries"
                            selected="true"
                            selectedValue={this.props.countries}
                            placeholder={placeholder}
                            searchPlaceholder={searchPlaceholder}
                            options={countriesOptions}
                            onDoneClick={handleCountriesChange}
                        />
                    );
                }}
            </Query>
        );
    };


    renderBookmarkButton = () => {
        const {isBookMark} = this.state;
        const {bookmarkCount, onMarkedListClear} = this.props;
        const disableBookmark = bookmarkCount === 0;

        if (isBookMark) {
            return (
                <Fragment>
                    <a href="#" onClick={onMarkedListClear} className="clear-marked-list">Clear Marked List</a>
                    <ButtonWithBadge disabled={disableBookmark} variant="light" counter={bookmarkCount} icon={fas.faBookmark} onClick={this.onBookmarkOn} className="bookmark marked"/>
                </Fragment>
            );
        } else {
            return (
                <ButtonWithBadge disabled={disableBookmark} variant="light" counter={bookmarkCount} icon={far.faBookmark} onClick={this.onBookmarkOn} className="bookmark"/>
            );
        }
    };

    renderCompareButton = () => {
        const {selectedPlayers} = this.props;
        const selectedCount = selectedPlayers.length;

        const disableCompare = !(selectedCount === 2 || selectedCount === 3);

        const players = {};
        if (selectedCount >= 2) {
            players['first'] = selectedPlayers[0].id;
            players['second'] = selectedPlayers[1].id;
        }
        if (selectedCount === 3) {
            players['third'] = selectedPlayers[2].id;
        }

        const url = queryString.stringifyUrl({
            url: 'talent-search/compare-players', query: players
        });

        return (
            <OverlayTrigger
                key="bottom"
                placement="bottom"
                overlay={
                    <Tooltip id={`tooltip-bottom`} className="compare-tooltip">
                        Compare Players
                    </Tooltip>
                }
            >
                <Link to={url}>
                    <ButtonWithBadge variant="light" counter={selectedCount} svg={icnCompare} className="compare-player" disabled={disableCompare}/>
                </Link>
            </OverlayTrigger>
        );
    };

    handleRegionsChange = (event) => {
        const {options} = event;
        const {onRegionsChange} = this.props;

        if (typeof onRegionsChange === 'function')
            onRegionsChange(options);
    };


    handleCountriesChange = (event) => {
        const {options} = event;
        const {onCountriesChange} = this.props;

        if (typeof onCountriesChange === 'function')
            onCountriesChange(options);
    };


    handleSearchChange = event => {
        const value = event.target.value;
        const {onSearchChange} = this.props;

        if (typeof onSearchChange === 'function')
            onSearchChange(value);
    }
}

const mapStateToProps = (state) => {
    return {
        aside_right_open: state.global.aside_right_open,
        selectedPlayers: state.talentSearch.datatable.selectedPlayers,
        search: state.talentSearch.search,
        tempSearch: state.talentSearch.tempSearch,
        regions: state.talentSearch.filters.regions,
        countries: state.talentSearch.filters.countries,
    }
};


const mapDispatchToProps = dispatch => {
    return {
        asideCollapse: (toggle) => dispatch(asideCollapse(toggle)),
        asideRightOpen: (isOpen) => dispatch(asideRightOpen(isOpen)),
        onSearchChange: (value) => dispatch(setSearchValue(value)),
        onRegionsChange: (regions) => dispatch(setRegionsFilter(regions)),
        onCountriesChange: (countries) => dispatch(setCountriesFilter(countries)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainToolbar);
